
import { NgModule } from '@angular/core';
import { AuthorizationComponent } from './auth.component';
import { AuthorizationService } from '../core/services/auth/auth.service';

@NgModule({
    declarations: [
        AuthorizationComponent
    ],
    imports: [
    ],
    providers: [
        AuthorizationService
    ]
})
export class AuthorizationModule { }